import {t} from 'i18next';
import AurIconButton from '../components/common/aur-button/AurIconButton';
import AurIcon, {IconNames} from '../components/common/aur-icon/AurIcon';
import {AurDataGridColDef, ViewInvoicesData} from '../types/types';

/*
Column name for view invoice table
*/

export const getViewInvoicesTableColumns = (
  handlePrintClick: (invoiceLink: string) => void,
  handleDownloadClick: (invoiceLink: string, invoiceNumber: string) => void
): AurDataGridColDef[] => {
  return [
    {
      field: 'invoiceDate',
      headerName: t('dateRangePicker.datePosted'),
      flex: 0.16,
      sortable: true,
      headerClassName: 'custom-header-inventory-table-grid',
      isDateColumn: true,
      renderCell: (params) => (
        <div className="customCellPaddingColumn1">
          <span>{params.value}</span>
        </div>
      ),
    },
    {
      field: 'documentNumber',
      headerName: t('viewInvoices.invoiceID'),
      flex: 0.35,
      sortable: false,
    },
    {
      field: 'invoiceAmount',
      headerName: t('viewInvoices.total'),
      flex: 0.41,
      sortable: false,
    },
    {
      field: 'iconColumn',
      sortable: false,
      flex: 0.08,
      isBorderNotRequired: true,
      renderCell: (params: {row: ViewInvoicesData}) => (
        <div tabIndex={-1}>
          <AurIconButton
            size="big"
            data-testid="print-button"
            icon={<AurIcon icon={IconNames.Print} />}
            onClick={() => handlePrintClick(params?.row.invoiceLink)}
            ariaLabel={t('viewInvoices.printButtonHint')}
          />
          <AurIconButton
            size="big"
            data-testid="download-button"
            icon={<AurIcon icon={IconNames.Download} />}
            onClick={() =>
              handleDownloadClick(
                params?.row.invoiceLink,
                params?.row.documentNumber
              )
            }
            ariaLabel={t('viewInvoices.downloadButtonHint')}
          />
        </div>
      ),
    },
  ];
};
